import angular from 'angular';

module.exports = angular.module('common.directives.login-link', [])
.directive('ocLoginLink', function ocLoginLink($window, $rootScope) {
  return {
    restrict: 'EC',
    template: require('./login-link.jade')(),
    link: function(scope) {
      scope.session = $rootScope.session;

      scope.login = function() {
        $window.location.href = '/login';
      };

      scope.logout = function() {
        scope.session.$logout().then(function() {
          window.location.href = '/';
        });
      };
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/login-link.js
 **/